import React, { forwardRef } from 'react';
import { cx } from '@emotion/css';
import { keyframesCss, skeletonStyles } from '../shared';
import { useLocalizationContext } from '@contrast-security-inc/design-system-foundations';
import * as messages from './translations';
export const Skeleton = forwardRef(({ className, height, width = '100%', borderRadius = 0, preset = 'normal', testId, ariaLabel, ...props }, ref) => {
    const classes = cx(skeletonStyles({ height, width, borderRadius, preset }), keyframesCss, className, 'ds-skeleton');
    const { formatMessage } = useLocalizationContext();
    return (React.createElement("div", { className: classes, ref: ref, "data-testid": testId, "aria-label": ariaLabel || formatMessage(messages, 'loading'), "aria-busy": "true", role: "status", ...props }));
});
Skeleton.displayName = 'Skeleton';
